<template>
<div class="chapter">
<div class="inner_page">
<p class="heading-line"><a id="page_3"></a><span class="bold">S<span class="small">OUTH</span> W<span class="small">ALES</span> V<span class="small">ALLEYS</span></span></p>
<h1 class="title">Railways and Industry on the BRECON &amp; MERTHYR</h1>
<p class="sub_heading">Bargoed to Pontsticill Jct. Pant to Dowlais Central</p>
<p class="author1"><span class="bold">JOHN HODGE and RAY CASTON</span></p>
<div class="img_container1">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?0b9140a8